import React from "react";

import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";

import FormValidator from "validatorjs";

import NewsletterService from "../../services/NewsletterService";
import NewsletterTextInput from "./NewsletterTextInput";
import CookieService from "../../services/CookieService";
import AnalyticsService from "../../services/AnalyticsService";

const NewsletterForm = ({
  subsite = null,
  source,
  placeholders,
  waitText,
  requiredText,
  buttonText,
  thankYouMessage,
}) => {
  const langcode = CookieService.get("DNSBELGIUM_LANGUAGE");
  FormValidator.useLang(langcode);

  const handleValidation = (values) => {
    const rules = {
      "first-name": "required",
      "last-name": "required",
      email: "email|required",
    };

    let errorMessages = {
      required: "Vul dit veld in.",
      email: "Vul een geldig e-mailadres in.",
    };

    if (langcode === "fr") {
      errorMessages = {
        required: "Veuillez remplir ce champs.",
        email: "Veuillez indiquer une adresse e-mail valide.",
      };
    }

    if (langcode === "en") {
      errorMessages = {
        required: "Please fill in this field.",
        email: "Please provide a valid e-mail address.",
      };
    }

    const validator = new FormValidator(values, rules, errorMessages);
    validator.check();

    return validator.errors.all();
  };

  const handleSubmit = async (values) => {
    if (subsite && subsite.id) {
      values.type = "subsite";
      values.subsite = subsite.id;
    } else {
      values.type = "general";
    }

    const response = await NewsletterService.subscribe(values);
    const data = await response.json();

    if (!response.ok) {
      return {
        [FORM_ERROR]: data.message,
      };
    }

    let category = "Newsletter";
    const action = "Subscribe newsletter";

    if (subsite) {
      category = `${category} ${subsite.label}`;
    }

    AnalyticsService.track(category, action, source);

    return {};
  };

  const renderThankYouMessage = () => {
    return (
      <div className="optin__thank-you">
        <span className="optin__icon">
          <svg
            className="icon-small"
            viewBox="0 0 18 16"
            role="presentation"
            focusable="false"
          >
            <use xlinkHref="#icon-check" />
          </svg>
        </span>
        <p>{thankYouMessage}</p>
      </div>
    );
  };

  const renderForm = ({
    handleSubmit,
    submitting,
    submitSucceeded,
    submitError,
  }) => {
    return (
      <form className="optin__form" onSubmit={handleSubmit} noValidate>
        <div className={`optin__input-group is-multi-field`}>
          {!submitSucceeded && (
            <React.Fragment>
              <div className="optin__columns">
                <label
                  className="optin__input-wrapper optin-required"
                  htmlFor="first-name"
                >
                  <span className="visually-hidden">
                    {placeholders["first-name"]}
                  </span>
                  <Field
                    id="first-name"
                    autocomplete="given-name"
                    component={NewsletterTextInput}
                    name="first-name"
                    type="text"
                    placeholder={placeholders["first-name"]}
                  />
                </label>
                <label
                  className="optin__input-wrapper optin-required"
                  htmlFor="last-name"
                >
                  <span className="visually-hidden">
                    {placeholders["last-name"]}
                  </span>
                  <Field
                    id="last-name"
                    autocomplete="family-name"
                    component={NewsletterTextInput}
                    name="last-name"
                    type="text"
                    placeholder={placeholders["last-name"]}
                  />
                </label>
              </div>
              <label
                className="optin__input-wrapper optin-required"
                htmlFor="email"
              >
                <span className="visually-hidden">{placeholders.email}</span>
                <Field
                  id="email"
                  autocomplete="email"
                  component={NewsletterTextInput}
                  name="email"
                  type="email"
                  placeholder={placeholders.email}
                />
              </label>
              <div className="optin__required-text">(*) {requiredText}</div>
              <button className="optin__button button is-large" type="submit">
                {submitting ? waitText : buttonText}
              </button>
            </React.Fragment>
          )}
          {submitSucceeded && renderThankYouMessage()}
        </div>

        {submitError && <div className="optin__error">{submitError}</div>}
      </form>
    );
  };

  return (
    <Form
      validate={handleValidation}
      onSubmit={handleSubmit}
      render={renderForm}
    />
  );
};

export default NewsletterForm;
